import { useKakaoLoader } from "react-kakao-maps-sdk";

const KAKAO_MAPS_APP_KEY = "115ef69a6d5eecfc78abf92f4f556080";

export default function useKakaoMapsLoader() {
  const [loading, error] = useKakaoLoader({
    appkey: KAKAO_MAPS_APP_KEY,
    libraries: ["services"],
  });
  return { isLoaded: !loading && !error, error };
}
